var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M295.822 1046.756c-17.067 0-34.133-5.689-45.511-22.756-28.444-28.444-28.444-68.267 0-96.711l409.6-409.6-409.6-403.911c-28.444-28.444-28.444-68.267 0-96.711s68.267-28.444 96.711 0l455.111 455.111c28.444 28.444 28.444 68.267 0 96.711l-455.111 455.111c-17.067 17.067-34.133 22.756-51.2 22.756z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.4c5c2937cfcb0cf1f535fca3c5e6b28a.svg";
export { ForwardRef as ReactComponent };